"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DistanceType = void 0;
var DistanceType;
exports.DistanceType = DistanceType;
(function (DistanceType) {
  DistanceType["EuclideanDistance"] = "euclideanDistance";
})(DistanceType || (exports.DistanceType = DistanceType = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/algorithm/lib/types.js
// module id = IJ9V
// module chunks = 1